const removeParamFromUrl = (paramName) => {
    const params = new URLSearchParams(window.location.search);
    params.delete(paramName);
    const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    window.history.replaceState({}, '', newUrl);
  };

export default removeParamFromUrl;